import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const items = ['Empezar fuerte y abandonar', 'Buscar motivación en vez de disciplina', 'Tener talento pero cero consistencia', 'Auto sabotaje constante', 'Excusas bien justificadas'];
export function IfYouveBeenSection() {
  return <section className="py-24 bg-[#0a0a0a]" data-id="element-113">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-114">
        <div className="text-center mb-16" data-id="element-115">
          <span className="text-[#C9A84C] font-bold tracking-widest text-sm uppercase" data-id="element-116">
            SI PASASTE POR ESTO...
          </span>
        </div>

        <div className="space-y-6" data-id="element-117">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="flex items-center gap-4 group" data-id="element-118">
              <ArrowRight className="text-[#C9A84C] w-5 h-5 flex-shrink-0 group-hover:translate-x-2 transition-transform" data-id="element-119" />
              <h3 className="text-xl md:text-3xl font-bold text-gray-300 group-hover:text-white transition-colors font-['Bebas_Neue'] tracking-wide leading-tight" data-id="element-120">
                {item}
              </h3>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-121">
          <p className="text-xl text-[#C9A84C] font-medium border-b-2 border-[#C9A84C] inline-block pb-1" data-id="element-122">
            Este programa es para vos.
          </p>
        </motion.div>
      </div>
    </section>;
}